import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import { Icon, IconColor, Spinner, Button } from '@/dc-shared-web/src'
import { faCloudArrowUp } from '@document-crunch/pro-regular-svg-icons'
import { cn } from '@dc-shared-web/lib'

type DnDZoneProps = {
  children?: React.ReactNode
  className?: string
  dragActiveClassName?: string
  disabled?: boolean
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T
  isDragActive?: boolean
}

export default function DnDZone({
  children,
  className,
  dragActiveClassName = 'tw-bg-primary-100',
  disabled = false,
  getRootProps,
  getInputProps,
  isDragActive,
}: DnDZoneProps) {
  return (
    <div
      className={cn(
        'tw-rounded-xl tw-border tw-border-dashed tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-space-y-4',
        isDragActive && dragActiveClassName,
        disabled && 'tw-opacity-50 tw-cursor-not-allowed',
        className
      )}
      {...getRootProps()}
    >
      <input {...getInputProps()} id='file-upload' />

      {disabled ? (
        <Spinner className='tw-h-8 tw-w-8' />
      ) : (
        <Icon
          icon={faCloudArrowUp}
          color={IconColor.tertiary}
          className='tw-h-12 tw-w-12'
        />
      )}

      <label htmlFor='file-upload'>Drag and drop your file here</label>

      <span>OR</span>

      <Button variant='outline' disabled={disabled} data-testid='browse-file'>
        Browse file
      </Button>

      {children}
    </div>
  )
}
